'use client'
import React from 'react'

import type { Hero } from '@/payload-types'

import { CMSLink } from '@/ui/components/CMSLink'
import RichText from '@/ui/components/RichText'
import { CMSImage } from '@/ui/atoms/CMSImage'

export const HighImpactHero: React.FC<Hero> = ({ buttons, image, richText }) => {
  return (
    <div className="relative -mt-[10.4rem] flex items-center justify-center text-white">
      <div className="container mb-8 z-10 relative flex items-center justify-center">
        <div className="max-w-[36.5rem] md:text-center">
          {richText && <RichText className="mb-6" data={richText} enableGutter={false} />}
          {Array.isArray(buttons) && buttons.length > 0 && (
            <ul className="flex md:justify-center gap-4">
              {buttons.map(({ button }, i) => {
                return (
                  <li key={i}>
                    <CMSLink {...button} />
                  </li>
                )
              })}
            </ul>
          )}
        </div>
      </div>
      <div className="min-h-[80vh] select-none">
        {image && typeof image === 'object' && (
          <CMSImage fill className="-z-10 object-cover" priority {...image} />
        )}
      </div>
    </div>
  )
}
